import { Box, Dialog, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { BatchControlReportForm } from "./components/BatchControlReportForm";
import { useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { NavigationContainer } from "@/components/NavigationButton";
import { AddButton } from "@/components/AddButton";
import {
  BatchControlTable,
  currentProductionDetails,
} from "./components/BatchControlTable";

const Body = styled(Box)`
  margin-bottom: 96px;
`;
export const BatchReportControl = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [dialogForm, setDialogForm] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const { data } = useQuery(currentProductionDetails, {
    variables: { params: { id: +(params.id || 0) } },
  });

  const selectedBatch = data?.report?.batchControlDetails?.find(
    (detail) => detail.id === selectedId
  );

  const goHome = () => navigate(`/formulario-reporte/${params.id}/produccion`);
  const goNext = () => navigate(`/formulario-reporte/${params.id}/suministros`);
  return (
    <Body>
      <BatchControlTable
        onEdit={(detail) => {
          setDialogForm(true);
          setSelectedId(detail.id);
        }}
      />
      <AddButton
        variant="contained"
        onClick={() => {
          setDialogForm(true);
        }}
      >
        <AddIcon />
        AGREGAR PARTIDA
      </AddButton>
      <NavigationContainer handleNext={goNext} handlePrev={goHome} />
      <Dialog
        open={dialogForm}
        onClose={() => {
          setDialogForm(false);

          setSelectedId(0);
        }}
        fullWidth
        PaperProps={{ sx: { maxWidth: 400 } }}
      >
        <BatchControlReportForm
          close={() => {
            setDialogForm(false);
            setSelectedId(0);
          }}
          defaultValues={
            selectedBatch
              ? {
                  id: selectedBatch.id,
                  initialHourometer:
                    selectedBatch.initialHourometer ?? undefined,
                  finalHourometer: selectedBatch.finalHourometer ?? undefined,
                  waste: selectedBatch.waste ?? undefined,
                }
              : undefined
          }
        />
      </Dialog>
    </Body>
  );
};
